import { connect } from 'react-redux';

import { IMapBlockDispatchProps, IMapBlockProps, MapBlock } from './index';
import { NavigationLinkTypes } from '../../constants/navigation';
import { selectGenplan } from '../../selectors/genplan';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';

export function mapStateToProps(state: IState): IMapBlockProps {
  const { village } = state.villageData;
  const { roadInfoList = [], stationInfoList = [] } = village;
  const interactiveGenplan = selectGenplan(state);

  return {
    commuteHighway: roadInfoList[0],
    commuteRailway: stationInfoList[0],
    generalPlanUrl: interactiveGenplan ? undefined : village.generalPlanUrl,
    geo: village.geo,
    regionHasRoads: !!village.regionId && state.countrysideRoadRegions.includes(village.regionId),
    regionHasStations: !!village.regionId && state.countrysideStationRegions.includes(village.regionId),
    regionId: village.regionId,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IMapBlockDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.Map)),
  };
}

export const MapBlockContainer = connect<IMapBlockProps, IMapBlockDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(MapBlock);
